import { render } from "./GridCategorias.vue?vue&type=template&id=09a9b8cd"
import script from "./GridCategorias.vue?vue&type=script&lang=js"
export * from "./GridCategorias.vue?vue&type=script&lang=js"

import exportComponent from "C:\\workspace\\CardsSistemasUece\\sistemas_uece\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__